export default __webpack_public_path__ + "static/media/globe.c824dd0f.png";